import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as TerminalBetslipActions from 'actions/TerminalBetslipActions';
import * as BetslipActions from 'actions/BetslipActions';
import * as UiActions from 'actions/UiActions';
import 'css/ViewMainMarkets.scss';
import { EVENT_STATUS, MARKET_STATUS } from 'constants/appConfig';
import { UI_ERROR_MESSAGE } from 'constants/ui';
import tapOrClick from 'utils/click-or-touch';
import Button from 'ui/Button';
import { isTerminal } from 'utils/UiHelper';
import { getErrorByCode } from '../utils/Helper';

class ViewOUButtons extends Component {
    addMarket(item) {
        if (
            this.props.betslip.betList.filter(
                (bet) => bet.eventId === this.props.ev.eventId
            ).length === 0 &&
            this.props.betslip.customBetEventId === null &&
            this.props.betslip.placedCustomBetMarkets.length === 0
        ) {
            const market = this.props.market;
            const ev = this.props.ev;
            const isLive = ev.live ? '1' : '0';

            if (!isTerminal()) {
                this.props.betslipActions.addMarket(
                    market.marketId,
                    item.betNr,
                    item.odds,
                    isLive,
                    market.sportId,
                    this.props.betslip.hasMarkets
                );
            } else {
                this.props.terminalBetslipActions.addMarket(
                    this.props.betslip,
                    market.eventId,
                    ev.eventName,
                    market.marketId,
                    item.betNr,
                    0,
                    item.odds,
                    item.bet,
                    market.marketName,
                    isLive,
                    ev
                );
            }
        } else {
            this.props.uiActions.notification(
                UI_ERROR_MESSAGE,
                getErrorByCode('BAD_COMBINATION')
            );
        }
    }

    removeMarket(marketId) {
        if (isTerminal()) {
            this.props.terminalBetslipActions.removeMarket(marketId);
            return;
        }
        if (this.props.betslip.betList.length > 1) {
            this.props.betslipActions.clearSystemMarket(
                this.props.market.eventId,
                marketId
            );
            return;
        }
        this.props.betslipActions.clearSingleMarket(
            this.props.market.eventId,
            marketId
        );
    }

    isActive(btnItem) {
        if (
            this.props.betslip.placedCustomBetMarkets.length === 0 &&
            this.props.betslip.customBetEventId === null
        ) {
            try {
                return this.props.betslip.betList.some(
                    (item) =>
                        item.gameId === this.props.market.marketId &&
                        item.betText === btnItem.bet &&
                        item.marketName === this.props.market.marketName &&
                        item.betNr === btnItem.betNr
                );
            } catch (error) {
                console.log(error);
            }
        }
    }

    getBetLabel(marketItem) {
        const [overItem] = this.props.market.itemList;
        return `${overItem === marketItem ? 'Over' : 'Under'} ${
            this.props.market.extraInfo
        }`;
    }

    renderButtonByMarketItemIndex(index) {
        const marketItem =
            this.props.market &&
            this.props.market.itemList &&
            this.props.market.itemList[index];
        const isDisabled =
            (this.props.ev && this.props.ev.status) !==
                EVENT_STATUS.IN_PROGRESS ||
            (this.props.market && this.props.market.status) !==
                MARKET_STATUS.ACTIVE;
        if (!marketItem) {
            return (
                <Button
                    margin="5px"
                    padding="20px"
                    fontSize="12px"
                    maxHeight="40px"
                    disabled
                >
                    -
                </Button>
            );
        }
        return (
            <Button
                active={this.isActive(marketItem)}
                flexDirection="column"
                padding={isDisabled ? '20px' : '8px'}
                fontSize="12px"
                margin="5px"
                maxHeight="40px"
                disabled={isDisabled}
                oddsYellow
                {...tapOrClick(
                    this.isActive(marketItem)
                        ? this.removeMarket.bind(
                              this,
                              this.props.market.marketId
                          )
                        : this.addMarket.bind(this, marketItem)
                )}
            >
                {isDisabled ? (
                    <div className="bet-value">-</div>
                ) : (
                    <Fragment>
                        <div className="bet-value">
                            {marketItem.odds.toFixed(2)}
                        </div>
                        <div className="bet-label">
                            {this.getBetLabel(marketItem)}
                        </div>
                    </Fragment>
                )}
            </Button>
        );
    }

    render() {
        return (
            <div className="view-main-markets row">
                <div className="col-5 main-market-33 ou-market-with-bottom-label">
                    {this.renderButtonByMarketItemIndex(0)}
                </div>
                <div className="col-5 main-market-33  ou-market-with-bottom-label">
                    {this.renderButtonByMarketItemIndex(1)}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { betslip: state.betslip };
}

function mapDispatchToProps(dispatch) {
    return {
        terminalBetslipActions: bindActionCreators(
            TerminalBetslipActions,
            dispatch
        ),
        betslipActions: bindActionCreators(BetslipActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewOUButtons);
